import api from './api';

export interface MercadoPagoPaymentLink {
  qrCode: string;
  paymentLink: string;
  preferenceId?: string;
}

const mercadoPagoService = {
  getPaymentLink: async (nroFormulario: number): Promise<MercadoPagoPaymentLink> => {
    const response = await api.get<MercadoPagoPaymentLink>(`/api/FacturasVenta/${nroFormulario}/mercado-pago/link`);
    return response.data;
  }
};

export default mercadoPagoService;

